












































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { dealTypeMap, currencyMap, totalClassList, exitTypeMap, permil } from '@/utils/finance';
import { projectManage, fundListCommon } from '@/api/finance.js';
import moment from 'moment';

@Component({
  components: {}
})
class WriteConfig extends Vue {
  amountList: any[] = [];
  amountType: number = 1; // 1: 零价 2: 自定义
  columns: any[] = [
    {
      title: '当前交易记录',
      dataIndex: 'label',
      width: 200,
      align: 'left'
    },
    {
      title: '币种',
      dataIndex: 'currencyText',
      width: 50,
      align: 'center'
    },
    {
      title: '实际退出金额',
      key: 'amount',
      scopedSlots: { customRender: 'amount' },
      width: 50,
      align: 'center'
    }
  ];
  effectDate: any = '';
  exitDate: any = '';

  @Prop()
  visible;

  @Prop()
  type;

  @Prop()
  projectId;

  handleCancel() {
    this.$emit('hide');
  }

  @Watch('amountType')
  onChange(val) {
    if (val === 1) {
      this.amountList.forEach(_ => {
        _.realizedAmount = 0;
        _.fmv = 0;
      });
    } else if (val === 2) {
      this.amountList.forEach(_ => {
        _.realizedAmount = 0;
        _.fmv = _.unrealizedCost;
      });
    }
  }

  @Watch('effectDate')
  onChangeDate(val) {
    this.fetchFundList();
  }


  created() {
    this.columns[2].title = this.type === 'writeDown' ? 'FMV' : '实际退出金额';
    this.exitDate = moment(new Date(), 'YYYY-MM-DD');
    this.effectDate = moment(new Date(), 'YYYY-MM-DD');
    this.fetchFundList();

  }

  fmvToCost(row) {
    row.fmv = row.amount;
  }

  handleOk() {
    let valid = this.amountList.every(
      _ => (this.type === 'writeDown' && (_.fmv || _.fmv === 0)) || (this.type === 'writeOff' && (_.realizedAmount || _.realizedAmount === 0))
    );
    if (!valid) {
      this.$message.error(`请填写各轮${this.type === 'writeDown' ? 'FMV' : '实际退出金额'}`);
      return;
    }
    this.save();
  }

  async fetchFundList() {
    try {
      let { projectId, effectDate } = this;
      let res = (await fundListCommon({ 
        projectId, 
        effectDate: moment(effectDate).format('YYYYMMDD') 
      })) || {};
      this.amountList = (res.data || []).map(_ => ({
        ..._,
        label: `${_.investId}-${_.classOfShare}-${moment(_.deliveryDate).format('YYYY.MM.DD')}-${_.fundName}`,
        id: _.investId,
        fmv: 0,
        realizedAmount: 0,
        currencyText: currencyMap[_.currency]
      }));
    } catch (e) {}
  }

  async save() {
    try {
      let params = {
        type: this.type === 'writeDown' ? 2 : 3,
        projectId: this.projectId,
        exitDate: this.type === 'writeDown' ? '' : moment(this.exitDate).format('YYYYMMDD'), // writeDown不填退出时间
        effectDate: moment(this.effectDate).format('YYYYMMDD'),
        list: this.amountList.map(_ => {
          _.realizedAmount = `${_.realizedAmount}`.replace(/,/g, '');
          _.fmv = `${_.fmv}`.replace(/,/g, '');
          return {
            dealId: _.id,
            amount: this.type === 'writeDown' ? _.fmv : _.realizedAmount
          };
        })
      };
      let res = await projectManage(params);
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.$emit('hide');
        this.$emit('refresh');
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  toString(data) {
    data.realizedAmount = permil(data.realizedAmount, 10, true);
    data.fmv = permil(data.fmv, 10, true);
  }

  toNumber(data) {
    data.realizedAmount = `${data.realizedAmount}`.replace(/,/g, '');
    data.fmv = `${data.fmv}`.replace(/,/g, '');
  }

  formatNum(value) {
    return `${value}`.replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ',');
  }

  parseNum(value) {
    return value.replace(/\$\s?|(,*)/g, '');
  }
}

export default WriteConfig;
